import { Router } from '@angular/router';
import groupBy from 'lodash-es/groupBy';

import { EVENT_SOURCE } from '@app/modules/core/constants/amplitude.constants';
import { SALES_CHANNEL } from '@app/modules/core/constants/query-params';
import {
  getAnchorFromURL, getURLParams, getURLWithoutAnchor,
  getURLWithoutParams
} from '@app/modules/ux/mappers/url-params.mapper';
import { HomeDeeplinkType } from '@shared/home-sections/entities/home-data.response';
import { ModuleEntity, ModuleEntityGroup } from '@app/entities/modules-country';
import { COUNTRY_MODULES_COLLECTION } from '@app/modules/core/mappers/modules.mapper';

export function deeplinkClick(deeplink: string, type: HomeDeeplinkType,
  router: Router = null, salesChannel: string = null, source: EVENT_SOURCE | string = null, branchCode: string = null): void {
  if (deeplink && type) {
    switch (type) {
      case HomeDeeplinkType.Gbrappi:
        window.open(deeplink, '_self');
        break;
      case HomeDeeplinkType.WhatsApp:
        window.open(deeplink, '_system');
        break;
      case HomeDeeplinkType.RouterLink:
        if (router) {
          const queryParams = getDeeplinkParams(deeplink, salesChannel, source, branchCode);
          const anchorUrl = getAnchorFromURLMapper(getDeeplink(deeplink));
          const anchorParams = anchorUrl ? { fragment: anchorUrl } : { fragment: null };
          router.navigate([getURLWithoutAnchorMapper(getDeeplink(deeplink))], {
            queryParams: queryParams, ...anchorParams
          });
        }
        break;
      default:
        break;
    }
  }
}

function getDeeplinkParams(url: string, salesChannel: string = null,
  source: EVENT_SOURCE | string = null, branchCode: string = null): { [key: string]: string } {
  const defaultParams = getURLParams(url);
  if (defaultParams[SALES_CHANNEL]) {
    return { ...defaultParams, source, branch_code: branchCode };
  } else if (salesChannel) {
    return {
      ...defaultParams, source, branch_code: branchCode,
      [SALES_CHANNEL]: salesChannel
    };
  } else {
    return { ...defaultParams, source, branch_code: branchCode };
  }
}

export function countryModulesByWidgetsConfig(
  widgets: string, splitThem: boolean | undefined = false
): ModuleEntity[] | ModuleEntityGroup[] {
  const widgetsModules = widgets ? widgets.replace(/ /g, '').split(',') : [];
  const allWidgets = widgetsModules?.map(_widget => {
    return COUNTRY_MODULES_COLLECTION?.find(x => x.widget === _widget)
  });
  const _all = allWidgets.filter(x => x);

  let _widgets = [];
  if (splitThem) {
    const group = groupBy(_all, 'splitKey');
    _widgets = Object.keys(group).map((key) => {
      const _key = key === 'null' || key === 'undefined' ? null : key;
      return { key: _key, value: group[key] };
    });
  } else {
    return _all;
  }
  
  return _widgets;
}

function getURLWithoutAnchorMapper(url: string): string {
  return getURLWithoutAnchor(url);
}

function getDeeplink(url: string): string {
  return getURLWithoutParams(url);
}

function getAnchorFromURLMapper(url: string): string {
  return getAnchorFromURL(url);
}
